export const styles = {
    singleProjectMainContainer: {
        width: "100%",
        padding: "10px",
        border: "1px solid #26292B",
        borderRadius: "var(--radius-2xl, 16px)",
        cursor: "pointer",
    } as const,
    img: {
        width: "100%",
        height: "30vh",
        objectFit: "cover",
        borderRadius: "var(--radius-sm, 6px)"
    } as const,
};

export const projectFileStyles = {
    mainContainer: {
        height: "88px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        gap: "auto",
    } as const,
    nameContainer: {
        width: "400px",
        display: "flex",
        alignItems: "center",
        gap: "10px",
    } as const,
    nameTypography: {
        width: "400px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    } as const,
    typeTypography: {
        width: "100px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    } as const,
    actionsContainer: {
        width: "200px",
        display: "flex",
        justifyContent: "space-between",
    } as const,
    imageRowStyle: {
        borderBottom:
            "1px solid var(--Colors-Border-border-secondary, #1F242F)",
        background:
            "linear-gradient(109deg, #5A84E6 -80.71%, rgba(90, 132, 230, 0.13) 36.11%, rgba(90, 132, 230, 0.00) 62.63%)",
    } as const,
    pdfRowStyles: {
        borderBottom: "1px solid var(--Colors-Border-border-secondary, #1F242F)",
        background: "linear-gradient(109deg, #2D2513 -80.71%, rgba(172, 147, 86, 0.13) 36.11%, rgba(191, 163, 96, 0.00) 62.63%)"
    } as const,
    mp3RowStyle: {
        borderBottom:
            "1px solid var(--Colors-Border-border-secondary, #1F242F)",
        background:
            "linear-gradient(109deg, #CC5433 -80.71%, rgba(204, 84, 51, 0.13) 36.11%, rgba(204, 84, 51, 0.00) 62.63%)",
    } as const,
    videoRowStyle: {
        borderBottom:
            "1px solid var(--Colors-Border-border-secondary, #1F242F)",
        background:
            "linear-gradient(109deg, #FFA726 -80.71%, rgba(255, 167, 38, 0.13) 36.11%, rgba(255, 167, 38, 0.00) 62.63%)",
    } as const,
    defaultRowStyle: {
        borderBottom:
            "1px solid var(--Colors-Border-border-secondary, #1F242F)",
        background:
            "linear-gradient(109deg, #66BB6A -80.71%, rgba(102, 187, 106, 0.13) 36.11%, rgba(102, 187, 106, 0.00) 62.63%);",
    } as const
}